module.exports = __webpack_public_path__ + "static/media/Uruli-S.69ca134f.jpeg";